import Vue from 'vue'
import Router from 'vue-router'

import WxLogin from '../view/login'
// import WxLogin from '../view/login-2'
import LiantongLogin from '../view/login-3'
import YbLogin from '../view/login-4'
import zjrobLogin from '../view/login-5'
import WxLoginBindAccount from '../view/WxLogin/WxLoginBindAccount'
import LoginFree from '../view/LoginFree'

import Homepage from '../view/homepage'

// import Log from '../view/log'
import resetPassword from '../view/resetPassword'
import FirstChangePassword from '../view/FirstChangePassword'

// 设置中心
// import SetFocusNav from '../view/setFocus/setFocusNav'
// import ContractTemplate from '../view/setFocus/ContractTemplate'

import Questionnaire from './Questionnaire'
import Parking from './Parking'
import Visitor from './Visitor'
import Ladder from './Ladder'
import InvestmentLeasing from './InvestmentLeasing'
import ElectronicControl from './ElectronicControl'
import AccessCtrl from './AccessCtrl'
import WaterManage from './WaterManage'
import Finance from './Finance'
import CustomPayment from './CustomPayment'
import Invoice from './Invoice'
import DataServicePark from './DataServicePark'
import VideoServices from './VideoServices'
import FireControl from './FireControl'
import AlarmManage from './AlarmManage'
import SmartDetection from './SmartDetection'
import RepairManagement from './RepairManagement'
import KeepWatch from './KeepWatch'
import Inspection from './Inspection'
import WorkAttendance from './WorkAttendance'
import Document from './Document'
import MessageService from './MessageService'
import IntellectualBrain from './IntellectualBrain'
import Activity from './Activity'
import Agent from './Agent'
import EnterpriseFavour from './EnterpriseFavour'
import ConfigCenter from './ConfigCenter'
import ResourceCenter from './ResourceCenter'
import SiteReservation from './SiteReservation'
import EnterpriseBigData from './EnterpriseBigData'
import PendingItems from './PendingItems'
import EpidemicSituation from './EpidemicSituation'
import PayService from './PayService'
import ValueAddedService from './ValueAddedService'
import UpperStrata from './UpperStrata'
import Workbench from './Workbench'
import User from './User'
import CallPolice from './CallPolice'
import Material from './Material'
import PropertyFee from './PropertyFee'
import Group from './Group'
import CustomerFlow from './CustomerFlow'
import FaceRecognition from './FaceRecognition'
import PoliticalCommunication from './PoliticalCommunication'
import GasManage from './GasManage'
import SteamManage from './SteamManage'
import VideoAlarm from './VideoAlarm'
import Lock from './Lock'
import hotelCheckIn from './hotelCheckIn'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'login',
      component: WxLogin
    },
    {
      path: '/login',
      name: 'login',
      component: WxLogin
    },
    {
      path: '/login_liantong',
      name: 'login-liantong',
      component: LiantongLogin
    },
    {
      path: '/login_3i',
      name: 'login-3i',
      component: YbLogin
    },
    {
      path: '/login_zjrob',
      name: 'login-zjrob',
      component: zjrobLogin
    },
    // {
    //   path: '/wx_login',
    //   name: 'wx-login',
    //   component: WxLogin
    // },
    {
      path: '/wx_login_bind_account',
      name: 'wx-login-bind-account',
      component: WxLoginBindAccount
    },
    {
      path: '/login_free/:id',
      name: 'login-free',
      component: LoginFree
    },
    {
      path: '/reset_password',
      name: 'resetPassword',
      component: resetPassword
    },
    {
      path: '/first_change_password',
      name: 'first-change-password',
      component: FirstChangePassword
    },
    {
      path: '/homepage',
      name: 'homepage',
      component: Homepage
    },

    /* 设置中心 */
    // {
    //   path: '/contract_template',
    //   name: 'contract-template',
    //   components: {
    //     default: InvestmentLeasingNav,
    //     a: ContractTemplate
    //   }
    // },
    /* 设置中心 */

    // 数据采集
    ...Questionnaire,

    // 智慧停车
    ...Parking,

    // 智慧访客
    ...Visitor,

    // 智慧梯控
    ...Ladder,

    // 智慧合约
    ...InvestmentLeasing,

    // 智慧用电
    ...ElectronicControl,

    // 智慧用水
    ...WaterManage,

    // 智慧门禁
    ...AccessCtrl,

    // 智慧财务
    ...Finance,

    // 智慧收费
    ...CustomPayment,

    // 智慧发票
    ...Invoice,

    // 园区数据
    ...DataServicePark,

    // 智慧监控
    ...VideoServices,

    // 智慧消防
    ...FireControl,

    // 报警中心
    ...AlarmManage,

    // 配电监测
    ...SmartDetection,

    // 智慧报修
    ...RepairManagement,

    // 智慧巡更
    ...KeepWatch,

    // 智慧巡检
    ...Inspection,

    // 智慧考勤
    ...WorkAttendance,

    // 智慧文书
    ...Document,

    // 智慧消息
    ...MessageService,

    // 智慧大脑
    ...IntellectualBrain,

    // 智慧活动
    ...Activity,

    // 智慧招商
    ...Agent,

    // 惠企服务
    ...EnterpriseFavour,

    // 配置中心
    ...ConfigCenter,

    // 资源中心
    ...ResourceCenter,

    // 场地服务
    ...SiteReservation,

    // 企业大数据
    ...EnterpriseBigData,

    // 待办
    ...PendingItems,

    // 疫情防控
    ...EpidemicSituation,

    // 缴费服务
    ...PayService,

    // 智慧增值
    ...ValueAddedService,

    // 上层平台
    ...UpperStrata,

    // 工作台
    ...Workbench,

    // 用户中心
    ...User,

    // 报警服务
    ...CallPolice,

    // 物资管理
    ...Material,

    // 物业费台账
    ...PropertyFee,

    // SAP数据对接
    ...Group,

    // 客流应用
    ...CustomerFlow,

    // 人脸应用
    ...FaceRecognition,

    // 小微政通
    ...PoliticalCommunication,

    // 智慧燃气
    ...GasManage,

    // 智慧蒸汽
    ...SteamManage,

    // 视频报警
    ...VideoAlarm,

    // 智慧门锁
    ...Lock,

    // 酒店入住
    ...hotelCheckIn
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js